import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

const fetchBenchmarkLite = async (user_id, token, objetivoId, canal, tipoServicio, fechaRange) => {
  let url = `${api_host}/reporte/online/indicadores/getBenchmarkDensity/?user=${user_id}&key=${api_auth}&objetivoId=${objetivoId}&token=${token}`;
  if (canal) url += `&canal=${encodeURIComponent(canal)}`;
  if (tipoServicio) url += `&tipo_servicio=${encodeURIComponent(tipoServicio)}`;
  if (fechaRange){
    const {fechaInicio, fechaTermino} = fechaRange
    if (fechaInicio) url += `&fechaInicio=${encodeURIComponent(fechaInicio)}`;
    if (fechaTermino) url += `&fechaTermino=${encodeURIComponent(fechaTermino)}`;
  };
  const response = await fetch(url);
  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const useBenchmarkLite = (objetivoId, canal, tipoServicio, fechaRange, options = {}) => {
  const {user, token} = getApiKeys();

  return useQuery({
    queryKey: ['benchmarkLite', user, objetivoId, canal || '', tipoServicio || '', fechaRange || ''],
    queryFn: () => fetchBenchmarkLite(user, token, objetivoId, canal, tipoServicio, fechaRange),
    enabled: !!user && !!token && !!objetivoId && !!canal && !!tipoServicio && !!fechaRange,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
    refetchInterval: 600000,
    retry: (failureCount, error) => {
      if (error?.status === 404 || error?.status === 400) return false;
      return failureCount < 2;
    },
    refetchOnWindowFocus: false,
    ...options
  });
};
